import React, {createRef} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import {
  baseStyles,
  BORDER_RADIUS,
  changeBodyColor,
  CONTENT_MAX_WIDTH,
  DRAWER_WIDTH,
  FONT_WEIGHT_BOLD,
  TOOLBAR_HEIGHT,
  TOOLBAR_HEIGHT_XS,
  withMediaQueries,
  withMultipleStyles
} from "src/styles/Styles";
import {Box, Button, Fade, List, Typography} from "@material-ui/core";
import ListItem from "@material-ui/core/ListItem";
import Drawer from "@material-ui/core/Drawer";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import Space from "../commons/Space";
import {
  ColorBackground,
  ColorBackgroundLanding,
  ColorBlack,
  ColorSeparatorLanding,
  ColorSubTitle,
  ColorTheme,
  ColorThemeLite,
  ColorTitle,
  ColorWhite
} from "src/styles/Colors";
import {FormattedHTMLMessage, FormattedMessage} from "react-intl";
import LinkHelper from "../../utils/LinkHelper";
import TextView from "../commons/TextView";
import {FontWeightBold, FontWeightMedium, FontWeightRegular} from "src/res/FontWeight";
import {
  getURLParameters,
  navBackOrHome,
  PathCampaignManage,
  PathCampaigns,
  PathHome,
  PathLogin
} from "src/js/components/routes/NavHelper";
import AppBar from "@material-ui/core/AppBar";
import zIndex from "@material-ui/core/styles/zIndex";
import LanguageIcon from "@material-ui/icons/Language";
import {changeLocale} from "src/js/actions/appActions";
import {logDebug} from "src/js/utils/AppLog";
import auth from "src/js/utils/auth";
import {doLoginGuest} from "src/js/actions/loginActions";
import {Skeleton} from "@material-ui/lab";
import {colorWithAlpha} from "src/js/utils/AppUtils";
import TouchableOpacity from "src/js/components/commons/TouchableOpacity";
import {API_ASSET_URI, SUPPORT_EMAIL} from "src/js/utils/services";
import {Swiper, SwiperSlide} from "swiper/react";
import {Autoplay, EffectCoverflow, Pagination} from 'swiper';
import 'swiper/swiper.scss';
import 'swiper/modules/pagination/pagination.scss';
import 'swiper/modules/autoplay/autoplay.scss';
import 'swiper/modules/effect-coverflow/effect-coverflow.scss';
import 'swiper/modules/effect-cube/effect-cube.scss';
import {fetchHome} from "src/js/actions/homeActions";
import ViewLoading from "src/js/components/commons/ViewLoading";
import ValueHelper, {floorFraction, roundFraction} from "src/js/utils/ValueHelper";
import {withStyles} from "@material-ui/core/styles";
import Slider from "@material-ui/core/Slider";
import SectionHeaderView from "src/js/components/commons/SectionHeaderView";
import FieldSpace from "src/js/components/commons/FieldSpace";
import Paper from "@material-ui/core/Paper";
import {AppIcon, IconBars} from "src/js/components/commons/AppIcon";
import {HashLink} from 'react-router-hash-link';
import utils from "src/js/utils/utils";
import ActivityView from "src/js/components/activityComponent/ActivityView";
import {CTA_TITLES} from "src/js/constants/ApiConstants";
import {cloneDeep} from "lodash";
import constants from "src/js/constants";
import DateTimeHelper from "src/js/utils/DateTimeHelper";
import ApiHelper, {isUserImageDummy} from "src/js/utils/ApiHelper";
import {PLAN_TYPE_PAID} from "src/js/components/activity/ManageActivity";
import {locString, locStringA} from "src/js/components/commons/ViewHelper";

const useStyles = (theme) => ({
  appBar: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    flex: 1,
    minHeight: TOOLBAR_HEIGHT,
    height: TOOLBAR_HEIGHT,
    paddingLeft: 0,
    paddingRight: 0,
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: zIndex.drawer + 1,
    borderWidth: 0,
    borderBottomWidth: 1,
    borderColor: 'rgba(8,4,0,0.1)',
    borderStyle: 'solid',
    backgroundColor: ColorWhite,
    position: 'fixed',
    left: 0,
    right: 0,
    top: 0,
    [theme.breakpoints.down('xs')]: {
      minHeight: TOOLBAR_HEIGHT_XS,
      height: TOOLBAR_HEIGHT_XS,
    },
  },
  appBarIn: {
    display: 'flex',
    flexDirection: 'row',
    flex: 1,
    height: TOOLBAR_HEIGHT,
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginRight: 0,
    paddingLeft: 16,
    paddingRight: 16,
    maxWidth: CONTENT_MAX_WIDTH,
    [theme.breakpoints.down('xs')]: {
      height: TOOLBAR_HEIGHT_XS,
      paddingLeft: 4,
      paddingRight: 4,
    },
  },
  hashLink: {
    padding: 8,
    borderRadius: 8,
    "&:hover": {
      backgroundColor: 'rgba(0,0,0,0.03)',
    },
    "&.Mui-focused": {
      backgroundColor: 'rgba(0,0,0,0.03)',
    },
    "&.Mui-selected": {
      backgroundColor: 'rgba(0,0,0,0.03)',
    },
    "&.Mui-selected:hover": {
      backgroundColor: 'rgba(0,0,0,0.03)',
    },
  },
  listItemMenu: {
    borderRadius: BORDER_RADIUS,
    margin: 8,
    marginTop: 10,
    marginBottom: 10,
    minHeight: 44,
    width: DRAWER_WIDTH - 40,
    "&:hover": {
      backgroundColor: 'rgba(0,0,0,0.03)',
    },
    "&.Mui-focused": {
      backgroundColor: 'rgba(0,0,0,0.03)',
    },
    "&.Mui-selected": {
      backgroundColor: 'rgba(0,0,0,0.03)',
    },
    "&.Mui-selected:hover": {
      backgroundColor: 'rgba(0,0,0,0.03)',
    },
  },
  sectionContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingLeft: 40,
    paddingRight: 40,
    marginRight: 0,
    [theme.breakpoints.down('xs')]: {
      paddingLeft: 16,
      paddingRight: 16,
    },
  },
  sectionContainerInner: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    maxWidth: CONTENT_MAX_WIDTH
  },
  buttonStartFree: {
    display: 'flex',
    flexDirection: 'row',
    borderRadius: 34,
    minHeight: 68,
    padding: 16,
    paddingLeft: 40,
    paddingRight: 40,
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
    boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 4px 12px 0 rgba(0, 0, 0, 0.2)',
    position: 'relative',
    backgroundColor: ColorTheme,
    [theme.breakpoints.down('xs')]: {
      minHeight: 50,
      borderRadius: 25,
      padding: 12,
      paddingLeft: 30,
      paddingRight: 30,
    }
  },
  buttonPlayContainer: {
    zIndex: 1,
    position: 'fixed',
    bottom: 12,
    left: 0,
    right: 0,
    pointerEvents: 'none',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('xs')]: {
      bottom: 10,
    }
  },
  fieldSlider: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    // paddingTop: 6,
    paddingBottom: 6,
    width: '100%',
  },
  slider: {
    display: 'flex',
    flex: 1,
    marginLeft: 6,
    marginRight: 6
  },
  containerGamePreview: {
    position: 'fixed',
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
    backgroundColor: 'rgba(255,255,255,0.9)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: zIndex.drawer + 1,
  },
  gamePreview: {
    width: '100%',
    backgroundColor: ColorBlack,
    borderRadius: 16,
    overflow: 'hidden',
  }
});

const HASH_DIALOG = 'old';

const IOSSlider = withStyles({
  root: {
    color: ColorTheme,
    height: 2,
    padding: '15px 0',
  },
  thumb: {
    height: 16,
    width: 16,
    // backgroundImage: require('src/images/ic_checked.png'),
    // // backgroundColor: ColorTheme,
    // boxShadow: iOSBoxShadow,
    marginTop: -8,
    marginLeft: -8,
    // '&:focus, &:hover, &$active': {
    //   boxShadow: '0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.3),0 0 0 1px rgba(0,0,0,0.02)',
    //   // Reset on touch devices, it doesn't add specificity
    //   '@media (hover: none)': {
    //     boxShadow: iOSBoxShadow,
    //   },
    // },
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 0px)',
    // top: -28,
    // '& *': {
    //   background: ColorTheme,
    //   color: '#fff',
    // },
  },
  track: {
    height: 2,
  },
  rail: {
    height: 2,
    opacity: 0.5,
    backgroundColor: '#bfbfbf',
  },
  mark: {
    backgroundColor: '#bfbfbf',
    height: 8,
    width: 1,
    marginTop: -3,
  },
  markActive: {
    opacity: 1,
    backgroundColor: 'currentColor',
  },
})(Slider);

const VALUE_MAX = 999999999;
const VIEW_MAX_WIDTH = 1400;

class Header extends React.Component {

  constructor(props) {
    super(props);

    this.menus = [
      {nameId: 'landing.menuPartners', section: 'partners'},
      {nameId: 'landing.menuLibrary', section: 'library'},
      {nameId: 'landing.menuProcess', section: 'process'},
      {nameId: 'landing.menuPricing', section: 'pricing'},
      {nameId: 'landing.menuTestimonials', section: 'testimonials'},
    ];
    this.state = {
      openDrawer: false
    }
  }

  render() {
    const {app, classes, isXS, isDrawerHidden, user, onHomeClicked, onLoginClicked, onChangeLocaleClicked} = this.props;

    return (
      <Box component="span">
        <AppBar className={classes.appBar} elevation={0} position="fixed" color={'transparent'}>
          <Toolbar className={classes.appBarIn}>
            {isDrawerHidden ?
              <React.Fragment>
                <IconButton
                  id={"buttonAccount"}
                  onClick={this.toggleDrawer}
                  edge="start"
                  style={{width: 48, height: 48, marginLeft: -4, marginRight: -4, borderRadius: 24, padding: 0, pointerEvents: 'auto'}}>
                  <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', width: 20, height: '100%', overflow: "hidden"}}>
                    <AppIcon icon={IconBars} />
                  </div>
                </IconButton>
                {isDrawerHidden && !isXS ? <Space vertical={16}/> : null}
              </React.Fragment>
              : null
            }

            <Button style={{color: ColorWhite}} size={"large"} onClick={onHomeClicked}>
              <div className={classes.flexRow}>
                {!isXS ?
                  <React.Fragment>
                    <img src={require('src/images/logo.png')} style={{width: isXS ? 32 : 40, height: isXS ? 32 : 40}} />
                    <Space vertical={isXS ? 8 : 12} />
                  </React.Fragment>
                   : null
                }
                <div style={{display: 'flex', flexDirection: 'column'}}>
                  <TextView variant={'h4'} text={'Rab7'} color={ColorTheme} fontWeight={FontWeightBold} />
                </div>
              </div>
            </Button>

            {!isDrawerHidden ?
              <div className={classes.viewRow} style={{marginLeft: 32, marginRight: 32}}>

                {this.menus.map((menu) => {
                  return <HashLink smooth to={'#'+ menu.section}>
                    <div className={classes.hashLink}>
                      <Typography variant={'subtitle1'} className={classes.typoMedium} style={{marginLeft: 8, marginRight: 8, color: ColorTitle}}>
                      <FormattedMessage id={menu.nameId} />
                      </Typography>
                    </div>
                  </HashLink>
                })}

              </div>
              : null
            }

            <div className={classes.grow} />

            {/*{!isXS ?*/}
            {/*  <div style={{borderRadius: BORDER_RADIUS, backgroundColor: ColorCard, marginLeft: !app.isLTR ? 24 : 0, marginRight: app.isLTR ? 24 : 0}}>*/}
            {/*    <LanguageSelector />*/}
            {/*  </div>*/}
            {/*  : null*/}
            {/*}*/}
            <Button
              variant="text"
              color="secondary"
              onClick={onChangeLocaleClicked}
              startIcon={<LanguageIcon/>}>
              {app.defaultLocale === 'en' ? 'عربى' : 'English'}
            </Button>
            <Space vertical={isXS ? 8 : 12} />
            <div style={{height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', marginLeft: 8, marginRight: 8}}>
              <Button
                disableElevation
                color={'primary'}
                variant={'contained'}
                size={isXS ? "medium" : "large"}
                onClick={onLoginClicked}>
                <FormattedMessage id={'generic.login'} />
              </Button>
            </div>
          </Toolbar>
        </AppBar>
        {isDrawerHidden ? this.getDrawerWrapperView() : null}
      </Box>
    );
  }

  toggleDrawer = () => {
    this.setState({
      openDrawer: !this.state.openDrawer
    });
  }

  onDrawerMenuClicked = (menu) => {
    this.toggleDrawer();
    this.props.onDrawerMenuClicked(menu);
  }

  getDrawerWrapperView() {
    const {app, classes, history, isXS, isDrawerHidden} = this.props;

    const getListItems = (menus) => {
      return (
        menus.map((menu, index) => {
          let isSelected = false;
          return (
            // <HashLink smooth to={'#'+ menu.section}>
            //   <div className={classes.hashLink}>
            //     <Typography variant={'subtitle1'} className={classes.typoMedium} style={{marginLeft: 8, marginRight: 8, color: ColorTitle}}>
            //       <FormattedMessage id={menu.nameId} />
            //     </Typography>
            //   </div>
            // </HashLink>
            <HashLink smooth to={'#'+ menu.section}>
              <ListItem className={classes.listItemMenu} button selected={isSelected} key={index +'-'+ menu.name} onClick={this.onDrawerMenuClicked.bind(this, menu)}>
                {/*<img src={isSelected ? menu.imageS : menu.image} width={24} height={24} style={{objectFit: 'contain'}} />*/}
                {/*<Space vertical={12} />*/}
                <Typography variant={'subtitle1'} className={classes.typoMedium} style={{paddingTop: 4, paddingBottom: 4, color: isSelected ? ColorWhite : ColorTitle}}>
                  <FormattedMessage id={menu.nameId} />
                </Typography>
              </ListItem>
            </HashLink>
          )
        })
      )
    };

    const drawerView = (
      <div className={classes.flexColumn} style={{width: DRAWER_WIDTH, backgroundColor: ColorWhite}}>
        <Toolbar style={{width: DRAWER_WIDTH, minHeight: isXS ? TOOLBAR_HEIGHT_XS : TOOLBAR_HEIGHT, paddingLeft: isXS ? 0 : 24, paddingRight: isXS ? 0 : 24, display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
          {isDrawerHidden ?
            <div className={classes.flexRow} style={{marginLeft: isXS ? -24 : 0, marginRight: isXS ? -24 : 20}}>
              <IconButton style={{color: ColorTitle}} onClick={this.toggleDrawer}>
                {app.isLTR ? <ChevronLeftIcon /> : <ChevronRightIcon />}
              </IconButton>
              <Space vertical={8} />
              {/*<Button style={{color: ColorWhite}} size={"large"} onClick={this.onHomeClicked}>*/}
              {/*  <div className={classes.flexRow}>*/}
              {/*    <Avatar variant="square" src={require('src/images/logo.png')} />*/}
              {/*    <Space vertical={10} />*/}
              {/*    <div style={{display: 'flex', flexDirection: 'column'}}>*/}
              {/*      <TextView textId={'app.name1'} color={ColorWhite} fontWeight={'bold'} />*/}
              {/*    </div>*/}
              {/*  </div>*/}
              {/*</Button>*/}
            </div>
            : <div className={classes.appHome}>
              <img src={require('src/images/logo_white.png')} style={{width: 42, height: 42, borderRadius: BORDER_RADIUS, backgroundColor: ColorTheme, padding: 8}} />
              <Space vertical={8} />
              <div style={{display: 'flex', flexDirection: 'column'}}>
                <TextView variant={'h5'} textId={'app.name1'} color={ColorTitle} fontWeight={'bold'} />
              </div>
            </div>
          }
        </Toolbar>
        <Space horizontal={10} />
        <List disablePadding>
          {getListItems(this.menus)}
        </List>
        <div className={classes.flexGrow} style={{height: '100%'}} />
      </div>
    );
    return (
      <div>
        {isDrawerHidden ?
          <Drawer
            variant="temporary"
            anchor={'left'}
            open={this.state.openDrawer}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
              onBackdropClick: this.toggleDrawer
            }}>
            {drawerView}
          </Drawer>
          : null
        }
      </div>
    );
  }
}

class SectionBanner extends React.Component {

  constructor(props) {
    super(props);
    this.banners = [
      {titleId: 'landing.bannerTitle1', subTitleId: 'landing.bannerSubTitle1', image: require('src/images/img_landing_1.webp'), titleColor: ColorBlack},
      {titleId: 'landing.bannerTitle2', subTitleId: 'landing.bannerSubTitle2', image: require('src/images/img_landing_2.webp'), titleColor: ColorWhite},
      {titleId: 'landing.bannerTitle3', subTitleId: 'landing.bannerSubTitle3', image: require('src/images/img_landing_3.webp'), titleColor: '#823c30'},
      {titleId: 'landing.bannerTitle4', subTitleId: 'landing.bannerSubTitle4', image: require('src/images/img_landing_4.webp'), titleColor: ColorWhite},
    ];
    if (!this.props.isXS) {
      this.banners.push({titleId: 'landing.bannerTitle1', subTitleId: 'landing.bannerSubTitle1', image: require('src/images/img_landing_1.webp'), titleColor: ColorBlack});
      this.banners.push({titleId: 'landing.bannerTitle2', subTitleId: 'landing.bannerSubTitle2', image: require('src/images/img_landing_2.webp'), titleColor: ColorWhite});
      this.banners.push({titleId: 'landing.bannerTitle3', subTitleId: 'landing.bannerSubTitle3', image: require('src/images/img_landing_3.webp'), titleColor: '#823c30'});
      this.banners.push({titleId: 'landing.bannerTitle4', subTitleId: 'landing.bannerSubTitle4', image: require('src/images/img_landing_4.webp'), titleColor: ColorWhite});
    }

    this.state = {
      opacity: 0,
      autoSlideInterval: 200,
    }
  }

  render() {
    const {classes, isXS, appWidth, appHeight} = this.props;
    let slideItemHeight = 0;
    let slideItemWidth = 0;
    let slideWidth = 0;
    let slideHeight = 0;
    let slideSpace = 0;
    let textHeight = 0;
    let perRow = 0;
    if (isXS) {
      textHeight = 160;
      slideItemHeight = Math.floor(appHeight - textHeight - TOOLBAR_HEIGHT_XS - 90);
      slideSpace = 16;
    } else {
      textHeight = 240;
      slideItemHeight = Math.floor(appHeight - textHeight - TOOLBAR_HEIGHT - 110);
      slideSpace = 20;
    }
    slideItemWidth = Math.min(400, Math.min(appWidth - 32, slideItemHeight));
    slideItemHeight = Math.min(slideItemWidth * 1.4, slideItemHeight);
    slideHeight = slideItemHeight + 20;
    perRow = Math.min(2.9, Math.max(1, appWidth / (slideItemWidth+slideSpace)));
    slideWidth = slideItemWidth * perRow + (perRow-1) * slideSpace;
    const paddingTopBottom = isXS ? TOOLBAR_HEIGHT_XS : TOOLBAR_HEIGHT;

    return (
      <Fade in={true} timeout={500}>
      <div className={classes.sectionContainer} style={{backgroundColor: ColorWhite, paddingTop: paddingTopBottom, paddingBottom: isXS ? 0 : paddingTopBottom, paddingLeft: 0, paddingRight: 0}}>
        <div className={classes.sectionContainerInner} style={{minHeight: appHeight - 2*paddingTopBottom}}>
          <div style={{flex: 1}}/>
          <div className={classes.viewColumnFullWidth} style={{minHeight: textHeight, justifyContent: 'center', paddingLeft: isXS ? 16 : 40, paddingRight: isXS ? 16 : 40}}>
            <TextView color={ColorTitle} variant={isXS ? 'h4' : 'h3'} align={'center'} fontWeight={FontWeightBold}>
              <FormattedHTMLMessage id={'landing.sectionBannerTitle'}/>
            </TextView>
            <TextView color={ColorSubTitle} variant={isXS ? 'h6' : 'h5'} align={'center'} fontWeight={FontWeightMedium} style={{marginTop: isXS ? 8 : 12}}>
              <FormattedHTMLMessage id={'landing.sectionBannerSubTitle'}/>
            </TextView>
          </div>
          <div style={{flex: 2}}/>
          <Swiper
            className={classes.viewRowFullWidthNoCenter}
            style={{justifyContent: 'center', height: slideHeight, width: slideWidth, '--swiper-pagination-bottom': '0px', opacity: this.state.opacity}}
            onSwiper={this.handleSwiper}
            onSlideChange={this.handleSlideChange}
            initialSlide={isXS ? this.banners.length - 1 : this.banners.length}
            effect={"coverflow"}
            autoplay={{
              delay: this.state.autoSlideInterval,
              pauseOnMouseEnter: true,
            }}
            loop={true}
            centeredSlides={true}
            spaceBetween={slideSpace}
            slidesPerView={perRow}
            pagination={{clickable: true}}
            modules={isXS ? [Pagination, Autoplay, EffectCoverflow] : [Autoplay, EffectCoverflow]}>
            {this.banners.map((banner, index) => {
              return <SwiperSlide>{this.getView(index, banner, slideItemWidth, slideItemHeight)}</SwiperSlide>;
            })}
          </Swiper>
          <div style={{flex: 2}}/>
        </div>
      </div>
      </Fade>
    );
  }

  getView = (index, banner, width, height) => {
    const {isXS, classes} = this.props;
    return (
      <Paper elevation={2} key={index} className={classes.viewColumnFullWidth} style={{position: 'relative', width: width, height: height, borderRadius: 16}}>
        <div className={classes.viewColumnFullWidth}>
          <img src={banner.image} style={{width: width, height: height, objectFit: 'cover', backgroundColor: ColorBackgroundLanding, borderRadius: 16}} />
        </div>
        <div className={classes.viewColumnFullWidth} style={{position: 'absolute', left: 0, top: 0, right: 0}}>
          <TextView align={'center'} textId={banner.titleId} color={banner.titleColor} variant={isXS ? 'h6' : 'h5'} fontWeight={FontWeightBold} style={{marginLeft: 20, marginRight: 20, marginTop: 24}}/>
          <TextView align={'center'} color={colorWithAlpha(banner.titleColor, 0.9)} variant={isXS ? 'body1' : 'h6'} fontWeight={FontWeightMedium} style={{marginLeft: 20, marginRight: 20, marginTop: 16}}>
            <FormattedHTMLMessage id={banner.subTitleId}/>
          </TextView>
        </div>
      </Paper>
    );
  }

  handleSwiper = (swiper) => {
    this.swiper = swiper;
  };

  handleSlideChange = () => {
    if (this.state.opacity === 0) {
      setTimeout(() => {
        this.setState({opacity: 1, autoSlideInterval: 4000});
      }, 300);
    }
  }
}

class SectionStats extends React.Component {

  render() {
    const {classes, isXS, counters} = this.props;
    const usersCount = counters ? counters.usersCount : 0;
    const campaignsCount = counters ? counters.campaignsCount : 0;
    const playsCount = counters ? counters.playsCount : 0;
    const countriesCount = counters ? counters.countriesCount : 0;
    const citiesCount = counters ? counters.citiesCount : 0;
    const gamesCount = counters ? counters.gamesCount : 0;

    return (
      <Fade in={true} timeout={500}>
        <div className={classes.sectionContainer} style={{backgroundColor: ColorBackgroundLanding, marginTop: isXS ? TOOLBAR_HEIGHT_XS : 0, paddingTop: isXS ? TOOLBAR_HEIGHT_XS : TOOLBAR_HEIGHT, paddingBottom: isXS ? TOOLBAR_HEIGHT_XS : TOOLBAR_HEIGHT}}>
          <div className={classes.sectionContainerInner}>
            {isXS ? <div className={classes.viewColumnFullWidth}>
                <div className={classes.viewRowFullWidth}>
                  {this.getCounterText(campaignsCount, 'landing.countCampaigns', counters)}
                  <div style={{backgroundColor: ColorSeparatorLanding, width: 1, height: 80}}/>
                  {this.getCounterText(playsCount, 'landing.countPlays', counters)}
                </div>
                <div className={classes.viewRowFullWidth}>
                  <div style={{width: '100%', padding: 30, paddingLeft: 40, paddingRight: 40}}>
                    <div style={{backgroundColor: ColorSeparatorLanding, height: 1, width: '100%'}}/>
                  </div>
                  <div style={{width: '100%', padding: 30, paddingLeft: 40, paddingRight: 40}}>
                    <div style={{backgroundColor: ColorSeparatorLanding, height: 1, width: '100%'}}/>
                  </div>
                </div>
                <div className={classes.viewRowFullWidth}>
                  {this.getCounterText(countriesCount, 'landing.countCountries', counters)}
                  <div style={{backgroundColor: ColorSeparatorLanding, width: 1, height: 80}}/>
                  {this.getCounterText(citiesCount, 'landing.countCities', counters)}
                </div>
                <div className={classes.viewRowFullWidth}>
                  <div style={{width: '100%', padding: 30, paddingLeft: 40, paddingRight: 40}}>
                    <div style={{backgroundColor: ColorSeparatorLanding, height: 1, width: '100%'}}/>
                  </div>
                  <div style={{width: '100%', padding: 30, paddingLeft: 40, paddingRight: 40}}>
                    <div style={{backgroundColor: ColorSeparatorLanding, height: 1, width: '100%'}}/>
                  </div>
                </div>
                <div className={classes.viewRowFullWidth}>
                  {this.getCounterText(gamesCount, 'landing.countGames', counters)}
                  <div style={{backgroundColor: ColorSeparatorLanding, width: 1, height: 80}}/>
                  {this.getCounterText(usersCount, 'landing.countUsers', counters)}
                </div>
              </div>
              : <div className={classes.viewColumnFullWidth}>
                <div className={classes.viewRowFullWidth}>
                  {this.getCounterText(campaignsCount, 'landing.countCampaigns', counters)}
                  <div style={{backgroundColor: ColorSeparatorLanding, width: 1, height: 80}}/>
                  {this.getCounterText(playsCount, 'landing.countPlays', counters)}
                  <div style={{backgroundColor: ColorSeparatorLanding, width: 1, height: 80}}/>
                  {this.getCounterText(usersCount, 'landing.countUsers', counters)}
                </div>
                <div className={classes.viewRowFullWidth}>
                  <div style={{width: '100%', padding: 30, paddingLeft: 40, paddingRight: 40}}>
                    <div style={{backgroundColor: ColorSeparatorLanding, height: 1, width: '100%'}}/>
                  </div>
                  <div style={{width: '100%', padding: 30, paddingLeft: 40, paddingRight: 40}}>
                    <div style={{backgroundColor: ColorSeparatorLanding, height: 1, width: '100%'}}/>
                  </div>
                  <div style={{width: '100%', padding: 30, paddingLeft: 40, paddingRight: 40}}>
                    <div style={{backgroundColor: ColorSeparatorLanding, height: 1, width: '100%'}}/>
                  </div>
                </div>
                <div className={classes.viewRowFullWidth}>
                  {this.getCounterText(countriesCount, 'landing.countCountries', counters)}
                  <div style={{backgroundColor: ColorSeparatorLanding, width: 1, height: 80}}/>
                  {this.getCounterText(citiesCount, 'landing.countCities', counters)}
                  <div style={{backgroundColor: ColorSeparatorLanding, width: 1, height: 80}}/>
                  {this.getCounterText(gamesCount, 'landing.countGames', counters, true)}
                </div>
              </div>
            }
          </div>
        </div>
      </Fade>
    );
  }

  getCounterText = (value, titleId, opacity) => {
    const {classes, isXS} = this.props;

    return (
      <div className={classes.flexColumn} style={{opacity: opacity}}>
        <TextView variant={isXS ? 'h4' : 'h3'} color={ColorTheme} align={'center'} fontWeight={FontWeightBold}>
          {value.toLocaleString()}
        </TextView>
        <TextView variant={isXS ? 'body1' : 'h6'} color={ColorTitle} align={'center'} fontWeight={FontWeightMedium} style={{marginTop: 6}}>
          <FormattedMessage id={titleId}/>
        </TextView>
      </div>
    );
  }
}

class SectionWhatWeDo extends React.Component {

  render() {
    const {classes, isXS, appWidth, appHeight} = this.props;
    const viewMaxWidth = Math.min(appWidth, VIEW_MAX_WIDTH);
    const imageSize = Math.min(500, viewMaxWidth * .35);

    return (
      <Fade in={true} timeout={500}>
        <div className={classes.sectionContainer} style={{backgroundColor: ColorWhite, paddingTop: isXS ? 2*TOOLBAR_HEIGHT_XS : TOOLBAR_HEIGHT, paddingBottom: isXS ? TOOLBAR_HEIGHT_XS : TOOLBAR_HEIGHT}}>
          <div className={classes.sectionContainerInner} style={{minHeight: appHeight*.7, maxWidth: viewMaxWidth, justifyContent: 'center'}}>
            <div className={isXS ? classes.viewColumnFullWidthNoCenter1 : classes.viewRowFullWidth} style={{alignItems: 'flex-end'}}>
              {isXS ?
                <React.Fragment>
                  <img src={require('src/images/img_landing_what_we_do.webp')} style={{width: viewMaxWidth-32, height: (viewMaxWidth-32)/4*3, borderRadius: 16, objectFit: 'cover'}}/>
                  <Space horizontal={40}/>
                </React.Fragment>
                : null
              }
              <div className={isXS ? classes.viewColumnFullWidthNoCenter1 : classes.flexColumnNoCenter}>
                <div className={classes.viewRow}>
                  <div className={classes.viewColumn} style={{backgroundColor: ColorThemeLite, borderRadius: isXS ? 20 : 25, minHeight: isXS ? 40 : 50, paddingLeft: 16, paddingRight: 16, justifyContent: 'center'}}>
                    <TextView color={ColorTheme} variant={'h5'} align={'center'} fontWeight={FontWeightMedium}>
                      <FormattedMessage id={'landing.sectionWhatWeDo'}/>
                    </TextView>
                  </div>
                </div>
                <TextView color={ColorTitle} variant={'h3'} align={'left'} fontWeight={FontWeightBold} style={{marginTop: isXS ? 24 : 32, marginBottom: isXS ? 16 : 20}}>
                  <FormattedMessage id={'landing.sectionWhatWeDoTitle'}/>
                </TextView>
                {this.getTextView('landing.sectionWhatWeDo1')}
                {this.getTextView('landing.sectionWhatWeDo2')}
                {this.getTextView('landing.sectionWhatWeDo3')}
                {this.getTextView('landing.sectionWhatWeDo4')}
              </div>
              {!isXS ?
                <React.Fragment>
                  <Space vertical={80}/>
                  <img src={require('src/images/img_landing_what_we_do.webp')} style={{width: imageSize, aspectRatio: 1, borderRadius: 16, objectFit: 'cover'}}/>
                </React.Fragment>
                : null
              }
            </div>
          </div>
        </div>
      </Fade>
    );
  }

  getTextView = (labelId) => {
    const {isXS} = this.props;
    return (
      <TextView color={ColorTitle} variant={isXS ? 'body1' : 'h5'} align={'left'} fontWeight={FontWeightRegular} style={{marginTop: isXS ? 16 : 32}}>
        <FormattedMessage id={labelId}/>
      </TextView>
    );
  }
}

class SectionHowItWorks extends React.Component {

  render() {
    const {classes, isXS, appWidth, appHeight, handleShowCampaigns} = this.props;
    const viewMaxWidth = Math.min(appWidth, VIEW_MAX_WIDTH);
    const imageSize = Math.min(500, viewMaxWidth * .27);

    return (
      <Fade in={true} timeout={500}>
        <div className={classes.sectionContainer} style={{backgroundColor: ColorBackgroundLanding, paddingTop: isXS ? TOOLBAR_HEIGHT_XS : TOOLBAR_HEIGHT, paddingBottom: isXS ? TOOLBAR_HEIGHT_XS : TOOLBAR_HEIGHT}}>
          <div className={classes.sectionContainerInner} style={{minHeight: appHeight*.7, maxWidth: viewMaxWidth, justifyContent: 'center'}}>
            <div className={isXS ? classes.viewColumnFullWidthNoCenter1 : classes.viewRowFullWidthNoCenter}>
              {!isXS ?
                <React.Fragment>
                  <img src={require('src/images/img_landing_how_it_works1.webp')} style={{width: imageSize, height: imageSize*1.7, borderRadius: 16, objectFit: 'fill'}}/>
                  <Space vertical={140}/>
                </React.Fragment>
                : null
              }
              <div className={classes.viewColumnFullWidthNoCenter1}>
                <div className={classes.viewRow}>
                  <div className={classes.viewColumn} style={{backgroundColor: ColorThemeLite, borderRadius: isXS ? 20 : 25, minHeight: isXS ? 40 : 50, paddingLeft: 16, paddingRight: 16, justifyContent: 'center'}}>
                    <TextView color={ColorTheme} variant={'h5'} align={'center'} fontWeight={FontWeightMedium}>
                      <FormattedMessage id={'landing.sectionHowItWorks'}/>
                    </TextView>
                  </div>
                </div>
                <TextView color={ColorTitle} variant={'h3'} align={'left'} fontWeight={FontWeightBold} style={{marginTop: isXS ? 24 : 32, marginBottom: isXS ? 16 : 20}}>
                  <FormattedMessage id={'landing.sectionHowItWorksTitle'}/>
                </TextView>
                {this.getTextView('landing.sectionHowItWorks1')}
                {this.getTextView('landing.sectionHowItWorks2')}
                {this.getTextView('landing.sectionHowItWorks3')}
                {this.getTextView('landing.sectionHowItWorks4')}
                {this.getTextView('landing.sectionHowItWorks5')}

                {/*{isXS ?*/}
                {/*  <img src={require('src/images/img_landing_how_it_works1.webp')} style={{width: viewMaxWidth-40, height: (viewMaxWidth-40)*1.7, borderRadius: 16, objectFit: 'fill', marginTop: 24}}/>*/}
                {/*  : null*/}
                {/*}*/}

                {/*<div className={classes.viewRow}>*/}
                {/*  <Button*/}
                {/*    onClick={handleShowCampaigns}*/}
                {/*    color={'primary'}*/}
                {/*    variant={'contained'}*/}
                {/*    size={'large'}*/}
                {/*    style={{marginTop: 32, minHeight: isXS ? 44 : 60, borderRadius: isXS ? 22 : 30, paddingLeft: 32, paddingRight: 32}}>*/}
                {/*    <TextView color={ColorWhite} variant={'h6'} fontWeight={FontWeightBold}>*/}
                {/*      <FormattedMessage id={'landing.createCampaign'}/>*/}
                {/*    </TextView>*/}
                {/*  </Button>*/}
                {/*</div>*/}
              </div>
            </div>
          </div>
        </div>
      </Fade>
    );
  }

  getTextView = (labelId) => {
    const {isXS} = this.props;
    return (
      <TextView color={ColorTitle} variant={isXS ? 'body1' : 'h5'} align={'left'} fontWeight={FontWeightRegular} style={{marginTop: isXS ? 16 : 32}}>
        <FormattedHTMLMessage id={labelId}/>
      </TextView>
    );
  }
}

class SectionPartners extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      isVisible: false
    }
    this.ref = createRef();
  }

  componentDidMount() {
    this.observer = new IntersectionObserver(([entry]) => {
        this.setState({isVisible: entry.isIntersecting});
      },
      {threshold: 0.1} // Trigger when 10% of the element is visible
    );

    if (this.ref.current) {
      this.observer.observe(this.ref.current);
    }
  }

  componentWillUnmount() {
    if (this.observer && this.ref.current) {
      this.observer.unobserve(this.ref.current);
    }
  }

  render() {
    const {app, classes, isXS, appWidth, partners} = this.props;
    const perRow = Math.max(2, Math.floor(appWidth / 220));
    const centeredSlides = partners && partners.length > perRow ? false : true;
    return (
      <Fade in={true} timeout={500}>
        <div ref={this.ref} className={classes.sectionContainer} style={{backgroundColor: ColorWhite, paddingTop: isXS ? TOOLBAR_HEIGHT_XS : TOOLBAR_HEIGHT, paddingBottom: isXS ? TOOLBAR_HEIGHT_XS : TOOLBAR_HEIGHT, paddingLeft: 0, paddingRight: 0}}>
          <div className={classes.viewColumnFullWidth}>
            <div className={classes.viewColumnFullWidth} style={{paddingLeft: isXS ? 16 : 40, paddingRight: isXS ? 16 : 40}}>
              <TextView color={ColorTitle} variant={'h3'} align={'center'} fontWeight={FontWeightBold}>
                <FormattedMessage id={'landing.partnersTitle'}/>
              </TextView>
              <TextView color={ColorSubTitle} variant={isXS ? 'body1' : 'h5'} align={'center'} fontWeight={FontWeightMedium} style={{marginTop: isXS ? 8 : 12, marginBottom: isXS ? 40 : 60}}>
                <FormattedMessage id={'landing.partnersSubTitle'}/>
              </TextView>
            </div>
            <Swiper
              className={classes.viewRowFullWidthNoCenter}
              style={{minHeight: 200}}
              autoplay={{
                delay: 800,
                pauseOnMouseEnter: true,
              }}
              loop={true}
              spaceBetween={0}
              centeredSlides={centeredSlides}
              slidesPerView={perRow}
              modules={[Autoplay]}>
              {partners && partners.map((partner, index) => {
                return <SwiperSlide>{this.getView(index, partner.imageUrl, partner.name)}</SwiperSlide>;
              })}
            </Swiper>
          </div>
        </div>
      </Fade>
    );
  }

  getView = (index, imageUrl, text) => {
    const {isXS, classes, appWidth} = this.props;
    const perRow = Math.max(2, Math.floor(appWidth / 220));
    const width = Math.floor(appWidth/perRow) - (perRow-1)*20;
    return (
      <div key={index} className={classes.viewColumnFullWidth}>
        <div className={classes.viewColumnFullWidth} style={{paddingLeft: 20, paddingRight: 20, maxWidth: width}}>
          <img src={imageUrl} style={{width: 120, height: 120, borderRadius: 16}} />
          <TextView numberOfLines={2} align={'center'} text={text} color={ColorTitle} variant={isXS ? 'body2' : 'body1'} fontWeight={FontWeightMedium} style={{marginTop: 6, wordBreak: 'break-all'}} />
        </div>
      </div>
    );
  }
}

class SectionLibrary extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      isVisible: false,
      previewActivity: null,
    }
    this.ref = createRef();
    this.hashHistory = [];

    this.games = [
      {id: 20, nameId: 'activity.manage.20.title', image: require('src/images/gameImages/roulette.webp')},
      {id: 13, nameId: 'activity.manage.13.title', image: require('src/images/gameImages/slot.webp')},
      {id: 22, nameId: 'activity.manage.22.title', image: require('src/images/gameImages/bingo.webp')},
      {id: 32, nameId: 'activity.manage.32.title', image: require('src/images/gameImages/brand_race.webp')},
      {id: 33, nameId: 'activity.manage.33.title', image: require('src/images/gameImages/poker.png')},
      {id: 27, nameId: 'activity.manage.27.title', image: require('src/images/gameImages/tic_tac_toe.webp')},
      {id: 30, nameId: 'activity.manage.30.title', image: require('src/images/gameImages/puzzle.webp')},
      {id: 35, nameId: 'activity.manage.35.title', image: require('src/images/gameImages/puzzle_slide.webp')},
      {id: 15, nameId: 'activity.manage.15.title', image: require('src/images/gameImages/flip_card.webp')},
      {id: 26, nameId: 'activity.manage.26.title', image: require('src/images/gameImages/match_pair.webp')},
      {id: 29, nameId: 'activity.manage.29.title', image: require('src/images/gameImages/match_three.webp')},
      {id: 25, nameId: 'activity.manage.25.title', image: require('src/images/gameImages/blackjack.webp')},
      {id: 31, nameId: 'activity.manage.31.title', image: require('src/images/gameImages/whac_a_mole.webp')},
      {id: 19, nameId: 'activity.manage.19.title', image: require('src/images/gameImages/guess.webp')},
      {id: 34, nameId: 'activity.manage.34.title', image: require('src/images/gameImages/map.webp')},
      {id: 12, nameId: 'activity.manage.12.title', image: require('src/images/gameImages/prediction.webp')},
      {id: 7, nameId: 'activity.manage.7.title', image: require('src/images/gameImages/review.webp')},
    ];
    this.games1 = [
      {id: 28, nameId: 'activity.manage.28.title', image: require('src/images/gameImages/quiz.webp')},
      {id: 36, nameId: 'activity.manage.36.title', image: require('src/images/gameImages/survey.webp')},
      {id: 11, nameId: 'activity.manage.11.title', image: require('src/images/gameImages/reel.webp')},
      {id: 37, nameId: 'activity.manage.37.title', image: require('src/images/gameImages/slides.webp')},

      {id: 100, subId: 1, nameId: 'activity.manage.101.title', image: require('src/images/gameImages/tap_tap_shots.webp')},
      {id: 100, subId: 2, nameId: 'activity.manage.102.title', image: require('src/images/gameImages/free_kick.webp')},
      {id: 100, subId: 3, nameId: 'activity.manage.103.title', image: require('src/images/gameImages/pac_rush.webp')},
      {id: 100, subId: 4, nameId: 'activity.manage.104.title', image: require('src/images/gameImages/traffic_go.webp')},
      {id: 100, subId: 5, nameId: 'activity.manage.105.title', image: require('src/images/gameImages/cannon_craze.webp')},
      {id: 100, subId: 6, nameId: 'activity.manage.106.title', image: require('src/images/gameImages/snake_dash.webp')},
      {id: 100, subId: 7, nameId: 'activity.manage.107.title', image: require('src/images/gameImages/arc_hunter.webp')},
      {id: 100, subId: 8, nameId: 'activity.manage.108.title'},
      {id: 100, subId: 9, nameId: 'activity.manage.109.title'},
    ];
    this.games = utils.shuffleArray(this.games);
    this.games1 = utils.shuffleArray(this.games1);

    this.cardWidth = this.props.isXS ? 242 : 282;
  }

  componentDidMount() {
    this.observer = new IntersectionObserver(([entry]) => {
        this.setState({isVisible: entry.isIntersecting});
      },
      {threshold: 0.1} // Trigger when 10% of the element is visible
    );

    if (this.ref.current) {
      this.observer.observe(this.ref.current);
    }
    window.addEventListener('hashchange', this.handleWindowHasChange);
  }

  componentWillUnmount() {
    if (this.observer && this.ref.current) {
      this.observer.unobserve(this.ref.current);
    }
    window.removeEventListener('hashchange', this.handleWindowHasChange);
  }

  handleWindowHasChange = (event) => {
    const oldUrl = event.oldURL;
    const newUrl = event.newURL;
    const oldHash = utils.getHashFromUrl(oldUrl);
    const newHash = utils.getHashFromUrl(newUrl);
    if (oldHash && oldHash !== newHash) {
      if (oldHash === HASH_DIALOG && !newHash) {
        if (this.state.previewActivity) {
          this.handleGameClose(this, true);
        }
      }
    }
  };

  getGameDefaultImageUrl = (type, subType = null)=> {
    return `${API_ASSET_URI}/images/activity/img-${type}${subType ? '-'+ subType : ''}.png`;
  }

  render() {
    const {classes, isXS, appWidth, gameActivities} = this.props;
    const {previewActivity} = this.state;
    const perRow = Math.max(1.5, appWidth / this.cardWidth);
    return (
      // <Fade in={true} timeout={500}>
      <div className={classes.viewColumnFullWidth}>
        <div ref={this.ref} className={classes.sectionContainer} style={{backgroundColor: ColorBackground, paddingTop: isXS ? TOOLBAR_HEIGHT_XS : TOOLBAR_HEIGHT, paddingBottom: isXS ? TOOLBAR_HEIGHT_XS : TOOLBAR_HEIGHT, paddingLeft: 0, paddingRight: 0}}>
          <div className={classes.viewColumnFullWidth}>
            <div className={classes.viewColumnFullWidth} style={{paddingLeft: isXS ? 16 : 40, paddingRight: isXS ? 16 : 40}}>
              <TextView color={ColorTitle} variant={'h3'} align={'center'} fontWeight={FontWeightBold}>
                <FormattedMessage id={'landing.libraryTitle'}/>
              </TextView>
              <TextView color={ColorSubTitle} variant={isXS ? 'body1' : 'h5'} align={'center'} fontWeight={FontWeightMedium} style={{marginTop: isXS ? 8 : 12, marginBottom: !gameActivities ? (isXS ? 40 : 60) : 0}}>
                <FormattedMessage id={'landing.librarySubTitle'}/>
              </TextView>
              {gameActivities ?
                <TextView color={ColorSubTitle} variant={isXS ? 'body2' : 'body1'} align={'center'} fontWeight={FontWeightMedium} style={{marginTop: isXS ? 8 : 12, marginBottom: isXS ? 40 : 60, fontStyle: 'italic'}}>
                  <FormattedMessage id={'landing.clickToPreview'}/>
                </TextView>
                : null
              }
            </div>
            <Swiper
              onSwiper={(swiper) => (this.swiper1 = swiper)}
              className={classes.viewRowFullWidthNoCenter}
              style={{marginTop: 12}}
              autoplay={{
                delay: 0,
              }}
              speed={3000}
              loop={true}
              spaceBetween={0}
              centeredSlides={true}
              slidesPerView={perRow}
              modules={[Autoplay]}>
              {this.games && this.games.map((item, index) => {
                return <SwiperSlide>{this.getItemView(index, item)}</SwiperSlide>;
              })}
            </Swiper>
            <Swiper
              onSwiper={(swiper) => (this.swiper2 = swiper)}
              className={classes.viewRowFullWidthNoCenter}
              style={{marginTop: 16}}
              autoplay={{
                delay: 0,
                reverseDirection: true
              }}
              speed={3000}
              loop={true}
              spaceBetween={0}
              centeredSlides={true}
              slidesPerView={perRow}
              modules={[Autoplay]}>
              {this.games1 && this.games1.map((item, index) => {
                return <SwiperSlide>{this.getItemView(index, item)}</SwiperSlide>;
              })}
            </Swiper>
          </div>
        </div>
        {this.renderGamePreview()}
      </div>
      // </Fade>
    );
  }

  getItemView = (index, item) => {
    const {isXS, classes, appWidth} = this.props;
    const perRow = Math.max(1.5, appWidth / this.cardWidth);
    const width = Math.floor(appWidth/perRow);
    const imageUrl = item.image || this.getGameDefaultImageUrl(item.id, item.subId);
    return (
      <div key={index} className={classes.viewColumnFullWidth}>
        <div className={classes.viewColumnFullWidth} style={{maxWidth: width, paddingLeft: 16, paddingRight: 16}}>
          <TouchableOpacity onClick={this.handleGameClick.bind(this, item.id, item.subId)} className={classes.viewColumnFullWidth} style={{maxWidth: width-32, borderRadius: 16}}>
            <div className={classes.viewColumnFullWidth} style={{maxWidth: width-32, borderRadius: 16}}>
              <img src={imageUrl} style={{width: width-32, height: (width-32)/4*3, borderRadius: 16}} />
              <TextView numberOfLines={2} align={'center'} textId={item.nameId} color={ColorTitle} variant={isXS ? 'body1' : 'h6'} fontWeight={FontWeightMedium} style={{marginTop: 12, paddingLeft: 12, paddingRight: 12, minHeight: isXS ? 44 : 54, wordBreak: 'break-all'}} />
              {/*<TextView numberOfLines={2} align={'center'} textId={item.detailId} color={ColorTitle} variant={isXS ? 'body2' : 'body1'} fontWeight={FontWeightMedium} style={{marginTop: 6, wordBreak: 'break-all'}} />*/}
            </div>
          </TouchableOpacity>
        </div>
      </div>
    );
  }

  renderGamePreview = () => {
    const {classes, isXS, app, appWidth, appHeight, history} = this.props;
    const {previewActivity} = this.state;
    if (!previewActivity) {
      return null;
    }

    let buttonHeight = isXS ? 40 : 48;
    let previewViewHeight = appHeight - buttonHeight - (isXS ? 20 : 24);
    let previewViewWidth = isXS ? appWidth : Math.min(appWidth - 8, previewViewHeight/12*9);
    return (
      <div className={classes.containerGamePreview}>
        <Paper elevation={2} className={classes.gamePreview} style={{width: previewViewWidth, height: previewViewHeight}}>
          <ActivityView
            key={previewActivity.type +'-'+ previewActivity.subType}
            activity={previewActivity}
            inPreview={true}
            isLTR={app.isLTR}
            locale={app.defaultLocale}
            isXS={true}
            windowWidth={previewViewWidth}
            windowHeight={previewViewHeight}
            width={previewViewWidth}
            height={previewViewHeight}
            hasUserInteraction={true}
            history={history}
            userId={previewActivity.business.id}
            userBId={previewActivity.business.id}
            userRab7Number={previewActivity.business.rab7Number}
            userImageUrl={previewActivity.business.imageUrl}
            ctaTitles={CTA_TITLES}
          />
        </Paper>
        <div className={classes.viewRow} style={{marginTop: 12, marginBottom: 8, pointerEvents: 'auto'}}>
          <Button
            variant={'contained'}
            color={'secondary'}
            size={isXS ? 'medium' : 'large'}
            onClick={this.handleGameClose}
            style={{minHeight: buttonHeight}}>
            <FormattedMessage id={'generic.close'}/>
          </Button>
          <Space vertical={16}/>
          <Button
            variant={'contained'}
            color={'primary'}
            size={isXS ? 'medium' : 'large'}
            onClick={this.handleCustomise.bind(this, previewActivity)}
            style={{minHeight: buttonHeight}}>
            <FormattedMessage id={'generic.customise'}/>
          </Button>
        </div>
      </div>
    )
  }

  processActivityData(activity) {
    this.activityData = cloneDeep(activity);
    this.activityData.business = {
      id: 2,
      rab7Number: 1000002,
      name: "Demo Rab7",
      imageUrl: require('src/images/img_demo_user.webp'),
    }

    ApiHelper.processActivityGameInfoConfigs(this.activityData);
    this.activityData.planType = this.activityData.ad ? this.activityData.ad.planType : 0;
    this.activityData.planId = this.activityData.ad ? this.activityData.ad.planId : 0;
    if (this.activityData.planId !== PLAN_TYPE_PAID) {
      this.activityData.planId = this.activityData.adInfo.plans[0].id;
      this.activityData.planType = this.activityData.adInfo.plans[0].type;
    }
    if (this.oldPlan) {
      this.activityData.planType = this.oldPlan.planType;
      this.activityData.planDuration = this.oldPlan.planDuration;
      this.activityData.planViews = this.oldPlan.planViews;
      this.activityData.planDailyViews = this.oldPlan.planDailyViews;
      this.activityData.planPrice = this.oldPlan.planPrice;
      this.activityData.planPayCurrency = this.oldPlan.planPayCurrency;
      this.activityData.planPayCurrencyCode = this.oldPlan.planPayCurrencyCode;
      this.activityData.planPay = this.oldPlan.planPay;
      this.activityData.planPayPoints = 0;
      this.activityData.planPayPointsValue = 0;
      this.activityData.planPaySuccess = this.oldPlan.planPaySuccess;
    }

    this.activityData.inReward = null;
    if (this.activityData.slotValues && this.activityData.slotValues.length > 0 && this.activityData.slotValues[0].offers && this.activityData.slotValues[0].offers.length > 0) {
      this.activityData.inReward = this.activityData.slotValues[0].offers[0];
      this.activityData.rewardState = constants.activity.state.ACTIVE;
      this.activityData.rewardSubState = this.activityData.inReward.type;
    }

    this.activityData.isEditing = true;
    this.activityData.startAt = DateTimeHelper.getDateFromDateString(this.activityData.startAt);
    this.activityData.endAt = DateTimeHelper.getDateFromDateString(this.activityData.endAt);
    this.activityData.endAtA = DateTimeHelper.getDateFromDateString(this.activityData.endAtA);
    this.activityData.noEditStartAt = !DateTimeHelper.isDateAfter(this.activityData.startAt, new Date());
    if (this.activityData.business.name !== '#'+ this.activityData.business.username) {
      this.activityData.userName = this.activityData.business.name;
    }
    if (!isUserImageDummy(this.activityData.business.imageUrl)) {
      this.activityData.userImageUrl = this.activityData.business.imageUrl;
    }
    this.processDummyValues();
    this.createPreviewActivity();
  }

  processDummyValues() {
    const {intl} = this.props;
    // process slots
    const slotValues = [];
    if (this.activityData.activityConfigs) {
      const reward = {
          id: 0,
          title: locStringA(intl, 'activity.dummyReward'),
          imageUrl: require('src/images/activityChallenge/11-img_rewards_won.png'),
      }
      const getOptionNumber = (i, isReverse) => {
        if (isReverse) {
          return -1;
        }
        return i;
      };
      const getOptionId = (optionNumber) => {
        if (optionNumber < 0) {
          return 100 * optionNumber;
        }
        if (this.activityData.type === constants.activity.types.GAME_TIC_TAC_TOE && optionNumber === 0) {
          return -10;
        }
        return -optionNumber;
      };
      const processSlotOption = (i, option, isReverse) => {
        if (!option) {
          option = {
            imageUrl: null,
            imageFiles: null,
            initialFiles: null,
            offers: [reward],
            points: '0',
            value1: 0,
            winLimit: '0',
            winILimit: '0',
          };
        }
        if (!option.number) {
          option.number = getOptionNumber(i, isReverse);
        }
        if (!option.id) {
          option.id = getOptionId(option.number);
        }
        if (!option.imageUrl) {
          option.imageUrl = ApiHelper.getSlotDefaultImageUrl(this.activityData, option.number);
        }
        option.value1 = ApiHelper.getSlotDefaultValue1(this.activityData, option.number);
        return option;
      };

      let totalSlots = Math.max(this.activityData.activityConfigs.slotTotalImages, this.activityData.activityConfigs.slotMinValues);
      // reverse slot
      if (this.activityData.type === constants.activity.types.GAME_BRAND_RACE
        || this.activityData.type === constants.activity.types.GAME_SPIN_N_DISCOVER
        || this.activityData.type === constants.activity.types.GAME_WHAC_A_MOLE) {
        totalSlots++;
      }
      const slotNumber_valuesMap = {};
      if (this.activityData.slotValues) {
        let index = 0;
        this.activityData.slotValues.forEach((slotValue) => {
          if (!slotValue.number) {
            slotValue.number = index;
          }
          slotNumber_valuesMap[slotValue.number] = slotValue;
          index++;
        });
      }
      for (let i = 0; i < totalSlots; i++) {
        let isReverse = false;
        if (i >= this.activityData.activityConfigs.slotMinValues && i >= this.activityData.activityConfigs.slotTotalImages) {
          isReverse = true;
        }
        const slotNumber = getOptionNumber(i, isReverse);
        let option = null;
        const exSlot = slotNumber_valuesMap[slotNumber];
        if (exSlot) {
          option = cloneDeep(exSlot);
        }
        option = processSlotOption(i, option, isReverse);
        slotValues.push(option);
      }
    }
    this.activityData.slotValues = slotValues;

    // process other images
    if (this.activityData.type === constants.activity.types.GAME_SPIN_N_DISCOVER
      || this.activityData.type === constants.activity.types.GAME_POKER
      || this.activityData.type === constants.activity.types.GAME_FLIP_CARD
      // || this.activityData.type === constants.activity.types.GAME_WHAC_A_MOLE
      || this.activityData.type === constants.activity.types.GAME_MATCH_PAIR
      || this.activityData.type === constants.activity.types.GAME_PUZZLE
      || this.activityData.type === constants.activity.types.GAME_PUZZLE_SLIDE) {
      if (!this.activityData.imageUrl1) {
        this.activityData.imageUrl1 = ApiHelper.getSlotDefaultCardImageUrl(this.activityData.type);
      }
    }
    if (this.activityData.type === constants.activity.types.GAME_SPIN_N_DISCOVER) {
      if (!this.activityData.imageUrl2) {
        this.activityData.imageUrl2 = ApiHelper.getSlotDefaultCardRevealImageUrl();
      }
    }

    const startAtDefault = DateTimeHelper.getDateAfterMinutesFromNow(0);
    const endAtDefault = DateTimeHelper.getDateAfterDays(startAtDefault, 7); // 1 week
    this.activityData.startAt = startAtDefault;
    this.activityData.endAt = endAtDefault;
    // process question
    if (this.activityData.type === constants.activity.types.QUESTION) {
      if (!this.activityData.qTitle) {
        this.activityData.qTitle = locString('activity.dummySurvey');
        this.activityData.qOptions = [
          {id: -1, name: locString('activity.dummySurveyO1')},
          {id: -2, name: locString('activity.dummySurveyO2')},
          {id: -3, name: locString('activity.dummySurveyO3')},
          {id: -4, name: locString('activity.dummySurveyO4')},
        ];
        this.activityData.showAnswers = true;
        this.activityData.imageUrl2 = require('src/images/dummy_question.png');
      }
    }

    // dummy opinion
    if (this.activityData.type === constants.activity.types.VISITOR_OPINION) {
      if (!this.activityData.qTitle) {
        this.activityData.qTitle = locString('activity.shareFeedbackDummy');
        this.activityData.value1Placeholder = intl.formatMessage({id: 'activity.ratingMinPoor'});
        this.activityData.value2Placeholder = intl.formatMessage({id: 'activity.ratingMaxOver'});
        this.activityData.imageUrl1 = require('src/images/dummy_opinion.png');
      }
    }

    // dummy location
    if (this.activityData.type === constants.activity.types.IDENTIFY_LOCATION) {
      if (!this.activityData.qTitle) {
        this.activityData.qTitle = locString('identifyLocationForThePlace');
        this.activityData.imageUrl1 = require('src/images/dummy_map.png');
      }
    }

    // dummy prediction
    if (this.activityData.type === constants.activity.types.PREDICTION) {
      if (!this.activityData.qTitle) {
        this.activityData.qTitle = intl.formatMessage({id: this.activityData.subType === 1 ? 'activity.dummyPredictionTitle' : 'activity.dummyPredictWinnerTitle'});
        this.activityData.value1Placeholder = intl.formatMessage({id: 'activity.dummyPredictionOption1Title'});
        this.activityData.value2Placeholder = intl.formatMessage({id: 'activity.dummyPredictionOption2Title'});
        this.activityData.imageUrl1 = require('src/images/dummy_prediction1.png');
        this.activityData.imageUrl2 = require('src/images/dummy_prediction2.png');
      }
    }

    // process guess
    if (this.activityData.type === constants.activity.types.GUESS) {
      if (!this.activityData.qTitle) {
        this.activityData.qTitle = locString('activity.dummyGuess');
        this.activityData.qOptions = [
          {id: -1, name: locString('activity.dummyGuessO1')},
          {id: -2, name: locString('activity.dummyGuessO2')},
          {id: -3, name: locString('activity.dummyGuessO3')},
          {id: -4, name: locString('activity.dummyGuessO4')},
        ];
        this.activityData.rightOption = 4;
        this.activityData.imageUrl2 = require('src/images/dummy_guess.png');
      }
    }

    // process questions
    if (this.activityData.type === constants.activity.types.QUESTIONNAIRE) {
      if (!this.activityData.questions) {
        const questions = [];
        const options1 = [
          {id: -11, name: locString('activity.dummyQuestionO1'), isRight: 1},
          {id: -12, name: locString('activity.dummyQuestionO2')},
          {id: -13, name: locString('activity.dummyQuestionO3')},
          {id: -14, name: locString('activity.dummyQuestionO4')},
        ];
        questions.push({
          id: -10,
          name: locString('activity.dummyQuestion'),
          options: options1,
          qOptions: options1,
        });
        const options2 = [
          {id: -21, name: locString('activity.dummyQuestion2O1')},
          {id: -22, name: locString('activity.dummyQuestion2O2')},
          {id: -23, name: locString('activity.dummyQuestion2O3')},
          {id: -24, name: locString('activity.dummyQuestion2O4'), isRight: 1},
        ]
        questions.push({
          id: -20,
          name: locString('activity.dummyQuestion2'),
          options: options2,
          qOptions: options2,
        });
        this.activityData.questions = questions;
        this.activityData.qTitle = locString('activity.dummyQuestionnaire');
        this.activityData.imageUrl2 = require('src/images/dummy_quiz.png');
      }
    }

    // survey
    if (this.activityData.type === constants.activity.types.SURVEY) {
      if (!this.activityData.questions) {
        const questions = [];
        const options1 = [
          {id: -11, name: locString('activity.dummySurveyO1'), isRight: 1},
          {id: -12, name: locString('activity.dummySurveyO2')},
          {id: -13, name: locString('activity.dummySurveyO3')},
          {id: -14, name: locString('activity.dummySurveyO4')},
        ];
        questions.push({
          id: -10,
          name: locString('activity.dummySurvey'),
          options: options1,
          qOptions: options1,
        });
        const options2 = [
          {id: -21, name: locString('activity.dummySurvey2O1'), isRight: 1},
          {id: -22, name: locString('activity.dummySurvey2O2')},
          {id: -23, name: locString('activity.dummySurvey2O3')},
          {id: -24, name: locString('activity.dummySurvey2O4')},
        ]
        questions.push({
          id: -20,
          name: locString('activity.dummySurvey2'),
          options: options2,
          qOptions: options2,
        });
        this.activityData.questions = questions;
        this.activityData.qTitle = locString('activity.dummySurveyTitle');
        this.activityData.imageUrl2 = require('src/images/dummy_survey.png');
      }
    }

    // reels
    if (this.activityData.type === constants.activity.types.CHALLENGE) {
      this.activityData.s2ImageUrl = require('src/images/dummy_reels.jpg');
      this.activityData.description = locStringA(intl, 'activity.dummyReelCaption');
      const subPosts = [
        {id: -1, title: locStringA(intl, 'activity.dummyReelPost1Caption'), videoUrl: require('src/images/dummy_reels_sp1.mp4')},
        {id: -2, title: locStringA(intl, 'activity.dummyReelPost2Caption'), imageUrls: [require('src/images/dummy_reels_sp2.jpg')], link: 'https://rab7.com', linkText: '3'},
        {id: -3, title: locStringA(intl, 'activity.dummyReelPost3Caption'), videoUrl: require('src/images/dummy_reels_sp3.mp4')},
        {id: -4, title: locStringA(intl, 'activity.dummyReelPost4Caption'), videoUrl: require('src/images/dummy_reels_sp4.mp4'), link: 'https://rab7.com', linkText: '4'},
      ];
      this.activityData.subPosts = subPosts;
    }

    if (this.activityData.type !== constants.activity.types.CHALLENGE) {
      // process cta2
      this.activityData.s2Link = 'https://rab7.com';
      this.activityData.s2ImageUrl = require('src/images/dummy_cta2.png');
      this.activityData.videoUrl = null;
    }
  }

  createPreviewActivity(playBgAudio = false) {
    this.previewActivity = null;
    if (this.activityData && this.activityData.activityConfigs
      && this.activityData.type !== constants.activity.types.OFFER
      && this.activityData.type !== constants.activity.types.VOUCHER
      && this.activityData.type !== constants.activity.types.DISCOUNT) {
      const subPosts = this.activityData.subPosts;
      if (subPosts && subPosts.length > 0) {
        subPosts.forEach((subPost) => {
          if (subPost.imageUrls && subPost.imageUrls.length > 0) {
            subPost.imageUrl = subPost.imageUrls[0];
            subPost.imageUrls;
          }
        });
      }
      this.activityData.subPosts = subPosts;

      this.previewActivity = cloneDeep(this.activityData);

      // process previewData
      this.previewActivity.previewBusiness = {
        name: this.previewActivity.userName || this.activityData.business.name,
        imageUrl: this.previewActivity.userImageUrl || this.activityData.business.imageUrl,
      };
      this.previewActivity.previewBasics = {
        title: this.previewActivity.title,
        imageUrl: this.previewActivity.imageUrl,
        reelInFocus: this.previewActivity.type === constants.activity.types.CHALLENGE && (!this.props.isXS || this.state.showPreview),
        themeColor: this.activityData.themeColor,
      };
      this.previewActivity.previewCta1 = {
        title: this.previewActivity.sName || this.previewActivity.business.name,
        link: this.previewActivity.sLink || this.previewActivity.business.link,
        imageUrl: this.previewActivity.sImageUrl || this.previewActivity.business.imageUrl,
        show: false,
      };
      this.previewActivity.previewCta2 = {
        linkText: this.previewActivity.s2LinkText,
        link: this.previewActivity.s2Link,
        description: this.previewActivity.description,
        imageUrl: this.previewActivity.s2ImageUrl,
        videoUrl: this.previewActivity.videoUrl,
        show: false,
      };
      this.previewActivity.previewGamePlay = {
        tries: this.previewActivity.type === constants.activity.types.GAME_FLIP_CARD ? this.previewActivity.flipsNeeded : this.previewActivity.consumeLimitPerUser,
        plays: this.previewActivity.consumeLimit,
        cardImageUrl: this.previewActivity.imageUrl1,
        cardRevealImageUrl: this.previewActivity.imageUrl2,
        showCards: 0,
        showKeyCards: 0,
      };
      this.previewActivity.previewBgAudio = {
        audioUrl: this.previewActivity.bgAudioUrl,
        play: playBgAudio
      };
      this.previewActivity.previewReferral = {
        offer: this.previewActivity.referralWinFun,
        points: this.previewActivity.referralWinPoints
      };
      this.previewActivity.previewPrediction = {
        name: this.previewActivity.qTitle,
        option1: {
          name: this.previewActivity.value1Placeholder,
          answer: this.previewActivity.rightOptionHint,
          imageUrl: this.previewActivity.imageUrl1,
        },
        option2: this.previewActivity.value2Placeholder || this.previewActivity.imageUrl2 ? {
          name: this.previewActivity.value2Placeholder,
          answer: this.previewActivity.rightOptionHintAr,
          imageUrl: this.previewActivity.imageUrl2,
        } : null
      };
      this.previewActivity.previewLocation = {
        name: this.previewActivity.qTitle,
        imageUrl: this.previewActivity.imageUrl1,
      };
      this.previewActivity.previewOpinion = {
        name: this.previewActivity.qTitle,
        imageUrl: this.previewActivity.imageUrl1,
        ratingMinTitle: this.previewActivity.value1Placeholder,
        ratingMaxTitle: this.previewActivity.value2Placeholder,
        contentTypes: this.previewActivity.contentTypes,
      };
      this.previewActivity.previewQuestion = {
        name: this.previewActivity.qTitle,
        options: this.previewActivity.qOptions,
        imageUrl: this.previewActivity.imageUrl2,
        rightOptionId: this.previewActivity.rightOptionId,
        showAnswers: this.previewActivity.showAnswers,
        correction: this.previewActivity.correction,
      };
      this.previewActivity.previewQuestions = {
        name: this.previewActivity.qTitle,
        imageUrl: this.previewActivity.imageUrl2,
        questions: this.previewActivity.questions,
        gameTime: this.previewActivity.gameTime,
        correction: this.previewActivity.correction,
        minCorrectAnswers: this.previewActivity.winnersBy > 0 ? this.previewActivity.winnersByValue : 0,
      };
      this.previewActivity.previewSubPosts = this.previewActivity.subPosts;
      this.previewActivity.previewInQuestion = this.previewActivity.inQuestion;
      this.processPreviewSlotValues();
    }
  }

  processPreviewSlotValues() {
    const cards = [];
    if (this.activityData.slotValues) {
      this.activityData.slotValues.forEach((slot) => {
        const slotNew = cloneDeep(slot);
        slotNew.points = slot.points;
        slotNew.offers = slot.offers;
        if (slot.imageFiles && slot.imageFiles.length > 0) {
          slotNew.imageUrl = slot.imageFiles[0].url;
        } else if (slot.imageUrl) {
          slotNew.imageUrl = slot.imageUrl;
        } else {
          slotNew.imageUrl = ApiHelper.getSlotDefaultImageUrl(this.activityData, slotNew.number);
        }
        if (slot.offers && slot.offers.length > 0) {
          const offers = [];
          slot.offers.forEach((offer) => {
            const offerNew = cloneDeep(offer);
            if (offerNew.videoFiles && offerNew.videoFiles.length > 0) {
              offerNew.videoUrl = offerNew.videoFiles[0].url;
              offerNew.videoStreamUrl = null;
            }
            if (offerNew.imageFiles && offerNew.imageFiles.length > 0) {
              offerNew.imageUrl = offerNew.imageFiles[0].url;
            }
            offers.push(offerNew);
          });
          slotNew.offers = offers;
        }
        cards.push(slotNew);
      });
    }

    this.previewActivity.previewCards = cards;
    this.previewActivity.slotValues = cards;
  }

  handleGameClick = (itemId, itemSubId) => {
    const {gameActivities} = this.props;
    if (gameActivities) {
      const effId = itemId + (itemSubId ? '-'+ itemSubId : '');
      logDebug('handleGameClick', effId);
      const previewActivity = gameActivities[effId];
      if (previewActivity) {
        this.processActivityData(previewActivity);
        this.setState({previewActivity: this.previewActivity}, () => {
          if (this.swiper1) {
            this.swiper1.autoplay.stop();
          }
          if (this.swiper2) {
            this.swiper2.autoplay.stop();
          }
          this.pushHash(HASH_DIALOG);

          if (typeof window != 'undefined' && window.document) {
            document.body.style.overflow = 'hidden';
          }
        });
      }
    }
  }

  handleGameClose = (event, noPop = false, onDone = null) => {
    this.setState({previewActivity: null}, () => {
      if (this.swiper1) {
        this.swiper1.autoplay.start();
      }
      if (this.swiper2) {
        this.swiper2.autoplay.start();
      }
      if (!noPop) {
        this.popHash();
      }
      if (typeof window != 'undefined' && window.document) {
        document.body.style.overflow = 'unset';
      }

      if (onDone) {
        onDone();
      }
    });
  }

  handleCustomise = (previewActivity) => {
    this.handleGameClose(null, false, () => {
      setTimeout(() => {
        this.props.handleCustomise(previewActivity);
      }, 300);
    });
  }

  pushHash = (hash) => {
    this.props.history.push({
      pathname: this.props.history.location.pathname,
      search: this.props.history.location.search,
      hash: hash,
    });
    this.hashHistory.push(hash);
  }

  popHash = () => {
    this.props.history.goBack();
    this.hashHistory.pop();
  }

  onBackClicked = () => {
    if (this.hashHistory.length > 0) {
      this.popHash();
    } else {
      navBackOrHome(this.props.history, this.canGoBack);
    }
  }
}

class SectionTestimonials extends React.Component {

  constructor(props) {
    super(props);
    this.testimonials = [
      {title: 'landing.testimonials1', userName: 'landing.testimonialsUser1'},
      {title: 'landing.testimonials2', userName: 'landing.testimonialsUser2'},
      {title: 'landing.testimonials3', userName: 'landing.testimonialsUser3'},
      {title: 'landing.testimonials4', userName: 'landing.testimonialsUser4'},
      {title: 'landing.testimonials5', userName: 'landing.testimonialsUser5'},
      {title: 'landing.testimonials6', userName: 'landing.testimonialsUser6'},
      {title: 'landing.testimonials7', userName: 'landing.testimonialsUser7'},
      {title: 'landing.testimonials8', userName: 'landing.testimonialsUser8'},
      {title: 'landing.testimonials9', userName: 'landing.testimonialsUser9'},
      {title: 'landing.testimonials10', userName: 'landing.testimonialsUser10'},
    ];

    this.state = {
      isVisible: false
    }
  }

  render() {
    const {app, classes, isXS, appWidth} = this.props;
    const perRow = Math.max(1, Math.floor(appWidth / 400));
    return (
      <Fade in={true} timeout={500}>
        <div className={classes.sectionContainer} style={{backgroundColor: ColorBackgroundLanding, paddingTop: isXS ? TOOLBAR_HEIGHT_XS : TOOLBAR_HEIGHT, paddingBottom: isXS ? TOOLBAR_HEIGHT_XS : TOOLBAR_HEIGHT, paddingLeft: 0, paddingRight: 0}}>
          <div className={classes.viewColumnFullWidth}>
            <div className={classes.viewColumnFullWidth} style={{paddingLeft: isXS ? 16 : 40, paddingRight: isXS ? 16 : 40}}>
              <TextView color={ColorTitle} variant={'h3'} align={'center'} fontWeight={FontWeightBold}>
                <FormattedMessage id={'landing.testimonialTitle'}/>
              </TextView>
              <TextView color={ColorSubTitle} variant={isXS ? 'body1' : 'h5'} align={'center'} fontWeight={FontWeightMedium} style={{marginTop: isXS ? 8 : 12, marginBottom: isXS ? 40 : 60}}>
                <FormattedMessage id={'landing.testimonialSubTitle'}/>
              </TextView>
            </div>
            <Swiper
              className={classes.viewRowFullWidthNoCenter}
              style={{justifyContent: 'center', minHeight: 260}}
              autoplay={{
                delay: 8000,
                pauseOnMouseEnter: true,
              }}
              loop={true}
              spaceBetween={0}
              centeredSlides={true}
              slidesPerView={perRow}
              pagination={{clickable: true}}
              modules={[Pagination, Autoplay]}>
              {this.testimonials.map((testimonial, index) => {
                return <SwiperSlide>{this.getView(index, testimonial.title, testimonial.userName)}</SwiperSlide>;
              })}
            </Swiper>
          </div>
        </div>
      </Fade>
    );
  }

  getView = (index, titleId, userNameId) => {
    const {isXS, classes, appWidth} = this.props;
    const perRow = Math.max(1, Math.floor(appWidth / 400));
    const width = Math.floor(appWidth/perRow) - (perRow === 1 ? 40 : (perRow-1)*20);
    return (
      <div key={index} className={classes.viewColumnFullWidthNoCenter1} style={{borderRadius: 16, padding: 20}}>
        <Paper elevation={0} className={classes.viewColumn} style={{backgroundColor: ColorWhite, borderRadius: 16, minHeight: 200, maxWidth: width}}>
          <div className={classes.viewColumn} style={{padding: isXS ? 12 : 16}}>
            <TextView align={'left'} textId={titleId} color={ColorTitle} variant={'body1'} fontWeight={FontWeightMedium} />
            <TextView align={'left'} textId={userNameId} color={ColorSubTitle} variant={'body1'} fontWeight={FontWeightMedium} style={{marginTop: 8}} />
          </div>
        </Paper>
      </div>
    );
  }
}

class SectionPrice extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      scaleDuration: 10,
      scaleViews: 0,
    };
  }

  componentDidMount() {
    this.processPlan();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.plans != this.props.plans) {
      this.processPlan();
    }
  }

  render() {
    if (!this.pvdMatrix) {
      return null;
    }

    const {classes, isXS, appWidth, plans} = this.props;
    const {
      scaleDuration,
      scaleViews,
    } = this.state;

    const viewMaxWidth = Math.min(appWidth, 735);
    const planValue = this.calculatePrice(scaleDuration, scaleViews);
    const basePrice = planValue.bPrice;
    const finalPrice = planValue.ePrice;
    const price = planValue.price;

    return (
      <Fade in={true} timeout={500}>
        <div className={classes.sectionContainer} style={{backgroundColor: ColorWhite, paddingTop: isXS ? TOOLBAR_HEIGHT_XS : TOOLBAR_HEIGHT, paddingBottom: isXS ? TOOLBAR_HEIGHT_XS : TOOLBAR_HEIGHT, paddingLeft: 0, paddingRight: 0}}>
          <div className={classes.sectionContainerInner}>
            <div className={classes.viewColumnFullWidth} style={{paddingLeft: isXS ? 16 : 40, paddingRight: isXS ? 16 : 40}}>
              <TextView color={ColorTitle} variant={'h3'} align={'center'} fontWeight={FontWeightBold}>
                <FormattedMessage id={'landing.priceTitle'}/>
              </TextView>
              <TextView color={ColorSubTitle} variant={isXS ? 'body1' : 'h5'} align={'center'} fontWeight={FontWeightMedium} style={{marginTop: isXS ? 8 : 12, marginBottom: isXS ? 40 : 60}}>
                <FormattedMessage id={'landing.priceSubTitle'}/>
              </TextView>
              <div className={classes.viewColumnFullWidth} style={{maxWidth: viewMaxWidth, paddingLeft: 8, paddingRight: 8}}>
                <div className={classes.fieldSlider}>
                  <div className={classes.viewPlaceholder} >
                    <SectionHeaderView labelId={'activity.planViewQ'} noBottomSpace={true}/>
                  </div>
                  <div className={classes.viewRowFullWidth}>
                    <IOSSlider
                      key={'scaleViews'}
                      className={classes.slider}
                      color={'secondary'}
                      onChange={this.onChange.bind(this, 'scaleViews')}
                      value={scaleViews}
                      defaultValue={scaleViews}
                      valueLabelFormat={this.getLabel.bind(this, this.viewsData)}
                      step={0}
                      valueLabelDisplay="auto"
                      marks={this.viewsData}
                      min={this.viewsData[0].value}
                      max={this.viewsData[this.viewsData.length - 1].value}
                    />
                  </div>
                </div>
                <FieldSpace multiplier={2}/>

                <div className={classes.fieldSlider}>
                  <div className={classes.viewPlaceholder} >
                    <SectionHeaderView labelId={'activity.planDurationQ'} noBottomSpace={true}/>
                  </div>
                  <div className={classes.viewRowFullWidth}>
                    <IOSSlider
                      key={'scaleDuration'}
                      className={classes.slider}
                      color={'primary'}
                      onChange={this.onChange.bind(this, 'scaleDuration')}
                      value={scaleDuration}
                      defaultValue={scaleDuration}
                      valueLabelFormat={this.getLabel.bind(this, this.durationData)}
                      step={0}
                      valueLabelDisplay="auto"
                      marks={this.durationData}
                      min={this.durationData[0].value}
                      max={this.durationData[this.durationData.length - 1].value}
                    />
                  </div>
                </div>
                <FieldSpace multiplier={2}/>
                <div className={classes.viewColumnFullWidth}>
                  <div className={classes.viewColumnFullWidth} style={{maxWidth: isXS ? 600 : 400}}>
                    <div className={classes.viewRow}>
                      {/*{finalPrice !== price && price > 0 ?*/}
                      {/*  <React.Fragment>*/}
                      {/*    <TextView*/}
                      {/*      variant={'h6'}*/}
                      {/*      color={ColorSubTitle}*/}
                      {/*      style={{textDecoration: 'line-through'}}*/}
                      {/*      text={<FormattedMessage id={'activity.moneyWithCurrency'} values={{value1: this.plan ? this.plan.currency : '', value2: price}} />}/>*/}
                      {/*    <Space verticalSpace={2}/>*/}
                      {/*  </React.Fragment>*/}
                      {/*  : null*/}
                      {/*}*/}
                      <TextView
                        variant={'h5'}
                        color={ColorTitle}
                        text={finalPrice > 0 ? <FormattedMessage id={'activity.moneyWithCurrency'} values={{value1: this.plan ? this.plan.currency : '', value2: finalPrice}} /> : <FormattedMessage id={'activity.chargeFree'}/>}
                        fontWeight={FONT_WEIGHT_BOLD} />
                    </div>
                  </div>
                  <FieldSpace multiplier={2}/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fade>
    );
  }

  onChange = (name, event, value) => {
    let {scaleDuration, scaleViews} = this.state;
    if (name === 'scaleDuration' || name === 'scaleViews') {
      if (name === 'scaleDuration') {
        scaleDuration = value;
      } else {
        scaleViews = value;
      }
    }
    this.setState({scaleDuration: scaleDuration, scaleViews: scaleViews});
  };

  getLabel = (data, value) => {
    const index = this.getMarksIndex(data, value);
    if (index >= 0) {
      return data[index].label;
    }
    return '';
  };

  getView = (imageUrl, text) => {
    const {isXS, classes} = this.props;
    return (
      <div className={classes.viewColumnFullWidth}>
        <img src={imageUrl} style={{width: 120, height: 120, borderRadius: 16}} />
        <TextView numberOfLines={1} align={'center'} text={text} color={ColorTitle} variant={isXS ? 'body2' : 'body1'} fontWeight={FontWeightMedium} style={{marginTop: 6}} />
      </div>
    );
  }

  processPlan() {
    const {plans} = this.props;
    this.plan = plans && plans.length > 0 ? plans[0] : null;
    if (this.plan) {
      const planDuration = 0;
      const planViews = 0;
      const planDailyViews = 0;

      this.pvdMatrix = this.plan.pVDMatrix;
      this.basePrice = this.pvdMatrix.bp;
      this.durationMultipliers = this.pvdMatrix.d;
      this.viewMultipliers = this.pvdMatrix.v;
      this.discountMultipliers = this.pvdMatrix.ds;
      this.questionFixed = this.pvdMatrix.qf;
      this.questionPercent = this.pvdMatrix.qp;
      this.showcaseFixed = this.pvdMatrix.sf;
      this.showcasePercent = this.pvdMatrix.sp;

      this.durationData = [];
      let scaleDuration = 0;
      if (this.durationMultipliers) {
        let index = 0;
        this.durationMultipliers.forEach((multiplier) => {
          const scaleValue = index++ * 10;
          this.durationData.push({value: scaleValue, label: ValueHelper.getDisplayValue(multiplier.k)});
          if (planDuration) {
            if (planDuration === multiplier.k) {
              scaleDuration = scaleValue;
            }
          } else if (multiplier.d === 1) {
            scaleDuration = scaleValue;
          }
        });
      }
      this.viewsData = [];
      let scaleViews = 0;
      if (this.viewMultipliers) {
        let index = 0;
        this.viewMultipliers.forEach((multiplier) => {
          const scaleValue = index++ * 8;
          this.viewsData.push({value: scaleValue, label: this.getDisplayValue(multiplier.k)});
          if (planViews) {
            if (planViews === multiplier.k) {
              scaleViews = scaleValue;
            }
          } else if (multiplier.d === 1) {
            scaleViews = scaleValue;
          }
        });
      }
      // const dailyViewsData = this.calculateDailyViewsData(scaleDuration, scaleViews);
      // const scaleDailyViews = planDailyViews ? planDailyViews : dailyViewsData.min;
      // const scaleDailyViews = planDailyViews ? planDailyViews : dailyViewsData.max;
      this.setState({scaleDuration, scaleViews});
    }
  }

  getMarksIndex(data, value) {
    return data.findIndex((mark) => mark.value === value);
  }

  calculatePrice(scaleDuration, scaleViews) {
    const {wallet} = this.props;
    const durationIndex = this.getMarksIndex(this.durationData, scaleDuration);
    const duration = this.durationMultipliers[durationIndex].k;
    const durationMultiplier = this.durationMultipliers[durationIndex].m;
    const viewsIndex = this.getMarksIndex(this.viewsData, scaleViews);
    let viewsCount = this.viewMultipliers[viewsIndex].k;
    const viewMultiplier = this.viewMultipliers[viewsIndex].m;
    let discount = 0;
    if (this.discountMultipliers && this.discountMultipliers.length > 0) {
      this.discountMultipliers.forEach((discountMultiplier) => {
        if ((discountMultiplier.v === 0 || discountMultiplier.v === viewsCount) && (discountMultiplier.d === 0 || discountMultiplier.d === duration)) {
          discount = discountMultiplier.m;
        }
      });
    }

    let cost = this.basePrice + durationMultiplier + viewMultiplier;
    let bPrice = cost;

    let qPrice = 0;
    // if (this.props.activityData.inQuestion) {
    //   qPrice = this.questionFixed + cost * this.questionPercent/100;
    // }
    let scPrice = 0;
    // if (this.props.activityData.showcase) {
    //   scPrice = this.showcaseFixed + cost * this.showcasePercent/100;
    // }
    cost += qPrice;
    cost += scPrice;
    let price = cost;

    let dPrice = price;
    if (discount > 0) {
      cost = Math.max(0, cost - cost * discount/100);
      dPrice = cost;
    }

    if (this.plan.exchangeRate !== 1) {
      qPrice *= this.plan.exchangeRate;
      scPrice *= this.plan.exchangeRate;
      bPrice *= this.plan.exchangeRate;
      price *= this.plan.exchangeRate;
      dPrice *= this.plan.exchangeRate;
      cost *= this.plan.exchangeRate;
    }
    cost = roundFraction(cost, 2);

    let points = undefined;
    let pointsValue = undefined;
    let minPoints = undefined;
    if (wallet && wallet.sPoints > 0 && wallet.sPointsValue > 0) {
      const perPointValue = wallet.sPointsValue / wallet.sPoints;
      minPoints = Math.ceil(0.01 / perPointValue);
      if (this.state.usePoints) {
        let sPointsValue = wallet.sPointsValue;
        points = wallet.sPoints;
        if (sPointsValue > cost) {
          sPointsValue = cost;
          points = Math.ceil(sPointsValue / perPointValue);
        }
        pointsValue = sPointsValue;
        pointsValue = floorFraction(pointsValue, 2);
        cost = Math.max(0, cost - sPointsValue);
      }
    }
    return {
      qPrice: roundFraction(qPrice, 2),
      scPrice: roundFraction(scPrice, 2),
      bPrice: roundFraction(bPrice, 2),
      price: roundFraction(price, 2),
      dPrice: roundFraction(dPrice, 2), // discounted price
      ePrice: roundFraction(cost, 2),
      minPoints: minPoints,
      points: points,
      pointsValue: pointsValue,
    };
  }

  getPlanDuration(scaleDuration) {
    let durationIndex = this.getMarksIndex(this.durationData, scaleDuration);
    if (durationIndex < 0) {
      durationIndex = 0;
    }
    return this.durationMultipliers[durationIndex].k;
  }

  getPlanViews(scaleViews) {
    let viewsIndex = this.getMarksIndex(this.viewsData, scaleViews);
    if (viewsIndex < 0) {
      viewsIndex = 0;
    }
    return this.viewMultipliers[viewsIndex].k;
  }

  getDisplayValue(value) {
    if (value === VALUE_MAX) {
      return '∞';
    }
    return ValueHelper.getDisplayValue(value);
  }
}

class SectionFooter extends React.Component {

  render() {
    const {app,classes, isXS, appWidth} = this.props;
    const viewMaxWidth = Math.min(appWidth, VIEW_MAX_WIDTH);

    return (
      <Fade in={true} timeout={500}>
        <div className={classes.sectionContainer} style={{backgroundColor: 'gray', paddingTop: isXS ? TOOLBAR_HEIGHT_XS*.5 : TOOLBAR_HEIGHT*.5, paddingBottom: isXS ? TOOLBAR_HEIGHT_XS : TOOLBAR_HEIGHT}}>
          <div className={classes.sectionContainerInner} style={{maxWidth: viewMaxWidth}}>
            <div className={classes.viewColumnFullWidthNoCenter1}>
              {this.getLinkView(<FormattedHTMLMessage id={'landing.contactEmail'} values={{value: SUPPORT_EMAIL}}/>, () => {
                LinkHelper.open("mailto:"+ SUPPORT_EMAIL);
              })}
              {this.getLinkView(<FormattedMessage id={'landing.tnc'} />, () => {
                LinkHelper.openTnc(app.defaultLocale);
              })}
              {this.getLinkView(<FormattedMessage id={'landing.privacyPolicy'} />, () => {
                LinkHelper.openTnc(app.defaultLocale);
              })}
              <TextView textId={'landing.footerNote'} color={ColorWhite} variant={isXS ? 'body2' : 'body1'} align={'left'} fontWeight={FontWeightMedium} style={{marginTop: 24}} />
              <TextView color={ColorWhite} variant={isXS ? 'body2' : 'body1'} align={'left'} fontWeight={FontWeightMedium} style={{marginTop: 12}}>
                <FormattedHTMLMessage id={'landing.copyright'}/>
              </TextView>
            </div>
          </div>
        </div>
      </Fade>
    );
  }

  getLinkView = (label, onClick) => {
    const {isXS} = this.props;
    return (
      <div>
        <Button variant={"text"} onClick={onClick} style={{marginLeft: -8, marginRight: -8}}>
          <TextView color={ColorWhite} variant={isXS ? 'body2' : 'body1'} align={'left'} fontWeight={FontWeightMedium}>
            {label}
          </TextView>
        </Button>
      </div>
    );
  }
}

class Landing extends React.Component {

  constructor(props) {
    super(props);

    if (this.props.history.location.hash) {
      this.props.history.replace({
        pathname: this.props.history.location.pathname,
        search: this.props.history.location.search,
      });
    }

    const searchParams = getURLParameters(decodeURIComponent(this.props.location.search));
    this.forceDisplay = searchParams['f'];
    this.state = {
      appWidth: window.appWidth,
      appHeight: window.appHeight,
    }
  }

  componentDidMount() {
    if (auth.isAuthenticated() && !this.forceDisplay) {
      this.props.history.replace(PathHome);
      return;
    }

    setTimeout(() => {
      changeBodyColor(ColorWhite);
      const hash = this.props.history.location.hash;
      const search = this.props.history.location.search;
      if ((hash && hash.length > 1) || (search && search.length > 1)) {
        this.props.history.replace(this.props.history.location.pathname);
        logDebug('DG:fReset');
      }
    }, 100);

    window.addEventListener('resize', this.handleWindowResize);

    this.props.fetchHome();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowResize);
  }

  handleWindowResize = (event) => {
    this.setState({
      appWidth: window.appWidth, appHeight: window.appHeight
    });
  }

  render() {
    const {isLoading, isBlockedLoading, user, app, classes, isDrawerHidden, landing} = this.props;
    const {appWidth, appHeight} = this.state;
    const isXS = appWidth < 600;

    if (isLoading) {
      return <ViewLoading/>;
    }

    return (
      <div className={classes.flexColumn} style={{backgroundColor: ColorWhite, position: 'relative'}}>
        <Header
          app={app}
          classes={classes}
          isXS={isXS}
          isDrawerHidden={isDrawerHidden}
          onDrawerMenuClicked={this.onDrawerMenuClicked}
          onHomeClicked={this.onHomeClicked}
          onLoginClicked={this.onLoginClicked}
          onChangeLocaleClicked={this.onChangeLocaleClicked}/>

        <SectionBanner classes={classes} isXS={isXS} appWidth={appWidth} appHeight={appHeight}/>

        <SectionStats classes={classes} isXS={isXS} appWidth={appWidth} appHeight={appHeight} counters={landing.counters} />

        <section id={'partners'} className={classes.viewColumnFullWidth}>
          <SectionPartners classes={classes} isXS={isXS} appWidth={appWidth} appHeight={appHeight} app={app} partners={landing.partners} />
        </section>

        <section id={'library'} className={classes.viewColumnFullWidth}>
          <SectionLibrary classes={classes} isXS={isXS} appWidth={appWidth} appHeight={appHeight} app={app} gameActivities={landing.gameActivities} history={this.props.history} intl={this.context.intl} handleCustomise={this.handleCustomise}/>
        </section>

        {/*<SectionWhatWeDo classes={classes} isXS={isXS} appWidth={appWidth} appHeight={appHeight}/>*/}

        <section id={'process'} className={classes.viewColumnFullWidth}>
          <SectionHowItWorks classes={classes} isXS={isXS} appWidth={appWidth} appHeight={appHeight} handleShowCampaigns={this.handleShowCampaigns}/>
        </section>

        <section id={'pricing'} className={classes.viewColumnFullWidth}>
          <SectionPrice classes={classes} isXS={isXS} appWidth={appWidth} appHeight={appHeight} app={app} plans={landing.plans} />
        </section>

        <section id={'testimonials'} className={classes.viewColumnFullWidth}>
          <SectionTestimonials classes={classes} isXS={isXS} appWidth={appWidth} appHeight={appHeight} app={app} />
        </section>

        <SectionFooter classes={classes} isXS={isXS} appWidth={appWidth} appHeight={appHeight} app={app} />

        <div className={classes.buttonPlayContainer}>
          <TouchableOpacity onClick={this.handleAddCampaign} style={{pointerEvents: 'auto'}}>
            <div className={classes.buttonStartFree}>
              <Skeleton variant={'rect'} animation={'wave'} height={'100%'} style={{position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: colorWithAlpha(ColorWhite, 0.1)}}/>
              <TextView variant={isXS ? 'h6' : 'h5'} textId={'landing.startFreeNow'} color={ColorWhite} style={{fontWeight: FontWeightBold}}/>
            </div>
          </TouchableOpacity>
        </div>
      </div>
    );
  }

  onDrawerMenuClicked = (menu) => {
    const shouldReplace = !menu.pathname;
    const {history} = this.props;
    if (shouldReplace) {
      history.replace({
        pathname: history.location.pathname,
        hash: menu.hash,
      });
    } else {
      history.push({
        pathname: history.location.pathname,
        hash: menu.hash,
      });
    }
  };

  onHomeClicked = () => {
    logDebug('onHomeClicked', 'onHomeClickedCalled');
    this.props.history.replace(this.props.history.pathname);
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
  }

  onLoginClicked = () => {
    const {user} = this.props;
    const isNoUser = !user || !user.id;
    const isUserGuest = user && !user.registerType;
    if (isNoUser || isUserGuest) {
      this.props.history.push(PathLogin);
    } else {
      this.props.history.push(PathHome);
    }
  }

  onChangeLocaleClicked = () => {
    const lastLocale = this.props.app.defaultLocale;
    let locale = null;
    if (lastLocale === 'en') {
      locale = {
        label: 'عربى',
        value: 'ar',
        direction: 'rtl'
      };
    } else {
      locale = {
        label: 'English',
        value: 'en',
        direction: 'ltr'
      };
    }
    this.props.changeLocale(locale);
  }

  handleAddCampaign = () => {
    const moveToAddCampaign = () => {
      this.props.history.push({
        pathname: PathCampaignManage,
      });
    }

    if (!auth.isAuthenticated()) {
      this.setState({isFetchInProgress: true, showMenuItem: null, showMenuElement: null});
      this.props.doLoginGuest({code: '' + Date.now()}).then(() => {
        moveToAddCampaign();
      }).catch(() => {
      });
    } else {
      moveToAddCampaign();
    }
  }

  handleShowCampaigns = () => {
    const moveToCampaigns = () => {
      this.props.history.push({
        pathname: PathCampaigns,
        search: '?f=1'
      });
    }

    if (!auth.isAuthenticated()) {
      this.setState({isFetchInProgress: true, showMenuItem: null, showMenuElement: null});
      this.props.doLoginGuest({code: '' + Date.now()}).then(() => {
        moveToCampaigns();
      }).catch(() => {
      });
    } else {
      moveToCampaigns();
    }
  }

  handleCustomise = (item) => {
    const moveToManageCampaign = () => {
      this.props.history.push({
        pathname: PathCampaignManage,
        search: item.subType ? `st=${item.subType}&fl=1` : `?t=${item.type}&fl=1`
      });
    }

    if (!auth.isAuthenticated()) {
      this.setState({isFetchInProgress: true, showMenuItem: null, showMenuElement: null});
      this.props.doLoginGuest({code: '' + Date.now()}).then(() => {
        moveToManageCampaign();
      }).catch(() => {
      });
    } else {
      moveToManageCampaign();
    }
  }
}

Landing.propTypes = {
  classes: PropTypes.object,
  app: PropTypes.object,
  isLoading: PropTypes.bool,
  isBlockedLoading: PropTypes.bool,
  history: PropTypes.object,
  user: PropTypes.object,
  children: PropTypes.element
};

Landing.contextTypes = {
  intl:PropTypes.object.isRequired
}

function mapStateToProps(state) {
  return {
    app: state.app,
    landing: state.home.landing,
    isLoading: state.isLoading,
    isBlockedLoading: state.isBlockedLoading,
    user: state.admin.user,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    changeLocale: (locale) => dispatch(changeLocale(locale)),
    fetchHome: () => dispatch(fetchHome()),

    doLoginGuest: (data) => dispatch(doLoginGuest(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withMultipleStyles(baseStyles, useStyles)(withMediaQueries([
  ['isDrawerHidden', theme => theme.breakpoints.down('sm'), {defaultMatches: true}],
  ['isXS', theme => theme.breakpoints.down('xs'), {defaultMatches: true}],
])(Landing)));
